import {default as cx} from "classnames"
import {Skeleton} from "primereact/skeleton"

function MetricCard({subtitle, title, value, badge, comparison, isLoading}) {
    return (
        <div className="card card-flush mb-5 w-100">
            <div className="card-header py-4">
                <h3 className="card-title align-items-start flex-row">
                    <div className="m-0">
                        <div className="d-flex flex-column align-items-start mb-2">
                            <span className="fs-5 fw-semibold text-gray-700">{subtitle}</span>
                            <span className="fs-3 fw-bold me-2">{title}</span>
                        </div>
                    </div>
                </h3>
            </div>
            {isLoading ? (
                <Skeleton className="card-body d-flex flex-center pt-0 h-150px" />
            ) : (
                <div className="card-body d-flex flex-center pt-0">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row justify-content-center align-items-center gap-4">
                            <span className="fw-bold fs-3hx text-dark lh-1">{value}</span>
                            {badge && <span className={cx("badge fs-5", `badge-${badge.variant}`)}>{badge.text}</span>}
                        </div>
                        {comparison && (
                            <div className="d-flex flex-row-fluid align-items-center justify-content-center fw-semibold fs-5 pt-5 text-gray-700">
                                {comparison}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default MetricCard
